import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainGridComponent } from './main-grid-component/main-grid.component';
import { OrdersCountMetadataResolver } from './resolvers/order-count-metadata/orders-count-metadata.resolver';
import { AccessDeniedComponent } from './security/components/access-denied/access-denied.component';
import { AlertGridComponent } from './watch-alert/alert-grid/alert-grid.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'order-management/active',
    data: {
      breadcrumb: {
        label: 'Home',
        info: { icon: 'home' },
      },
    },
  },
  {
    path: 'order-management',
    pathMatch: 'full',
    redirectTo: 'order-management/active',
  },
  {
    path: 'order-management/watch-alert',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: AlertGridComponent,
        loadChildren: () =>
          import('./watch-alert/watch-alert.module').then(
            (m) => m.WatchAlertModule,
          ),
      },
    ],
  },
  {
    path: 'order-management',
    children: [
      {
        path: ':status',
        pathMatch: 'full',
        component: MainGridComponent,
        data: {
          disableBreadcrumb: true,
        },
        resolve: { ordersCountMetadata: OrdersCountMetadataResolver },
      },
    ],
  },

  {
    path: '**',
    pathMatch: 'full',
    component: AccessDeniedComponent,
    data: {
      disableBreadcrumb: true,
    },
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
